import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { ProjectList } from '@/components'
import { Header } from '@/modules/header'
import { routes } from '@/router'
import { ResourceType } from '@/schemas'
import { ga, traceEvent } from '@/utils/ga'

import { ProjectCreateContainer } from './project-create'
import { ProjectDetailContainer } from './project-detail'

export const ProjectContainer = () => {
  React.useEffect(() => {
    ga('event', traceEvent.navigation.events.show_navigation, {
      event_category: traceEvent.navigation.event_categories.ef_pmo,
      event_label: traceEvent.navigation.event_labels.projects,
      action: traceEvent.navigation.action,
    })
  }, [])

  return (
    <Switch>
      <Route exact path={routes.project.create()} component={ProjectCreateContainer} />
      <Route exact path={routes.project.page(':projectId')} component={ProjectDetailContainer} />
      <Route
        exact
        path={routes.project.home()}
        render={() => (
          <>
            <Header resourceType={ResourceType.PROJECT} />
            <ProjectList isReplaceRouter={true} shouldProportionDisplay={true} />
          </>
        )}
      />
      <Redirect to={routes.project.home()} />
    </Switch>
  )
}
